import { type FieldClaimDisplay } from './fieldClaimDisplay';

/**
 * The sentence naming a field's claimants: "Alex is editing this field",
 * "Alex and Sam are editing this step". Shared by the blocked-tap toast and
 * the blocked overlay's accessibility label so they always read the same.
 */
export function claimantsEditingLabel(
  claims: FieldClaimDisplay[],
  noun: 'field' | 'step',
): string {
  const names = claims.map((c) => c.name);
  const list =
    names.length > 1
      ? `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
      : (names[0] ?? '');
  return `${list} ${names.length > 1 ? 'are' : 'is'} editing this ${noun}`;
}
